import { ToastService } from "./core/services/toast.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ElementRef, Injectable } from "@angular/core";
import { decode } from "base64-arraybuffer";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { TitleCasePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { getHours, getMinutes, getSeconds } from "date-fns";
import { rolesLabels, statuses } from "./app.const";

@Injectable({
	providedIn: "root",
})
export class Utils {
	static previousUrl = "";
	static currentUrl = "";

	categoriesType: { name: string; code: string }[] = [];
	servicesType: { name: string; code: string }[] = [];

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private toast: ToastService,
		private http: HttpClient,
		private titleCasePipe: TitleCasePipe
	) {
		this.categoriesType = this.categoriesList();
		this.servicesType = this.servicesList();
	}

	public static sortBySelected(x: { selected: any }, y: { selected: any }) {
		return x.selected === y.selected ? 0 : x.selected ? -1 : 1;
	}

	public static sortByActive(x: { active: any }, y: { active: any }) {
		return x.active === y.active ? 0 : x.active ? -1 : 1;
	}

	public static sortByInActive(x: { active: any }, y: { active: any }) {
		return y.active === x.active ? 0 : y.active ? -1 : 1;
	}

	public static sortByIsActive(x: { isActive: any }, y: { isActive: any }) {
		return x.isActive === y.isActive ? 0 : x.isActive ? -1 : 1;
	}

	public static sortByAlphabetic(x: { name: any }, y: { name: any }) {
		if (x.name < y.name) {
			return -1;
		}
		if (x.name > y.name) {
			return 1;
		}
		return 0;
	}

	public static base64ImgToBlob(base64: string, format: string) {
		return new Blob([new Uint8Array(decode(base64))], {
			type: `image/${format}`,
		});
	}

	public static blobImgToFile(blob: Blob, format: string) {
		return new File([blob], `${new Date().getTime()}.${format}`, {
			type: blob.type,
		});
	}

	public static base64ImgToFile(base64: string, format: string) {
		const blob = this.base64ImgToBlob(base64, format);
		return this.blobImgToFile(blob, format);
	}

	public static getMaxDate() {
		return new Date().toISOString();
	}

	public static getFullMinutesOfDate(date: Date) {
		const h = getHours(date) * 60;
		const m = getMinutes(date);

		return h + m;
	}

	public static transformMinutesToDate(minutes: number) {
		return new Date(new Date().setHours(0, minutes, 0, 0));
	}

	public static transformDDMMYYYYToDate(date: string) {
		return new Date(
			Number(date.split("-")[2]),
			Number(date.split("-")[1]),
			Number(date.split("-")[0])
		);
	}

	public geoContinent(country_code: string) {
		return this.http.get(
			`https://restcountries.com/v3.1/alpha/${country_code}`
		);
	}

	public geoReverse(lat: number, lng: number, zoom: number) {
		return this.http.get(
			`nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=${zoom}&addressdetails=1`
		);
	}

	public idCode(id: number) {
		let code = "#000000";
		return code.substring(0, code.length - id.toString().length) + id;
	}

	// private clickedMarker: L.Marker<any> | undefined;
	// private clickedMarkerData: any;
	// private clickedMarkerIcon: L.DivIcon | undefined;

	innerHtml(element: { innerHTML: any }, htmlString: any) {
		element.innerHTML = htmlString;
	}

	public static image(path: string, user: boolean = false) {
		if (!path || path === "")
			return user
				? "assets/img/icons/user.svg"
				: "assets/img/icons/no-image.svg";
		return environment.api.url + path;
	}

	public static renameFile(file: File, newName: string) {
		const blob = file.slice(0, file.size, file.type);

		const splitName = file.name.split(".");
		const ext = splitName[splitName.length - 1];

		return new File([blob], newName + "." + ext, {
			type: file.type,
		});
	}

	private coords: GeolocationCoordinates;
	async getPosition(toast?: boolean): Promise<GeolocationCoordinates> {
		return new Promise(async (resolve) => {
			const toastMsg = () => {
				if (toast)
					this.toast.show(
						"No puedo obtener tu ubicación, verifica si has otorgado los permisos.",
						"",
						"warn"
					);
			};
			try {
				return navigator.geolocation.getCurrentPosition(
					async (location) => {
						this.coords = location.coords;
						resolve(location.coords);
					},
					async () => {
						toastMsg();
						if (this.coords) resolve(this.coords);
						else resolve(null);
					},
					{ timeout: 10000 }
				);
			} catch (error) {
				console.error(error);
				toastMsg();
				if (this.coords) resolve(this.coords);
				else resolve(null);
			}
		});
	}

	public serviceType(key: string): string {
		// if (serviceTypeList[key]) return serviceTypeList[key].value;
		return "";
	}

	public categoryType(key: string): string {
		// if (CategoryTypes[key]) return CategoryTypes[key].value;
		return "";
	}

	public categoryTypeKey(value: string): string {
		const find = this.categoriesList().find((a) => a.name === value);
		if (find) return find.code;
		return "";
	}

	public categoriesList() {
		const list: { name: string; code: string }[] = [];
		// for (const key in CategoryTypes) {
		//   if (Object.prototype.hasOwnProperty.call(CategoryTypes, key)) {
		//     const element = CategoryTypes[key];
		//     list.push({ name: element.value, code: element.key });
		//   }
		// }
		return list;
	}

	public servicesList() {
		const list: { name: string; code: string }[] = [];
		// for (const key in serviceTypeList) {
		//   if (Object.prototype.hasOwnProperty.call(serviceTypeList, key)) {
		//     const element = serviceTypeList[key];
		//     list.push({ name: element.value, code: element.key });
		//   }
		// }
		return list;
	}

	getLabelStatus(active: boolean) {
		return statuses.find((a) => a.value == !!active).label;
	}

	getStatus(active: boolean) {
		return statuses.find((a) => a.value == !!active);
	}

	public userTypesList() {
		const list: { name: string; code: string }[] = [];
		// for (const key in UserTypes) {
		//   if (Object.prototype.hasOwnProperty.call(UserTypes, key)) {
		//     const element = UserTypes[key];
		//     list.push({ name: element.value, code: element.key });
		//   }
		// }
		return list;
	}

	getLabelUserType(typeUser: number) {
		for (const key of rolesLabels) {
			if (key.id === typeUser) return key.label;
		}
		return "";
	}

	getLabelNotificationType(type: number) {
		switch (type) {
			case 1:
				return "Admin";
			case 2:
				return "Gimnasio";
			case 3:
				return "Entrenador";
			case 4:
				return "Atleta";
			default:
				break;
		}
		return "Todos";
	}

	async onErrorHttp(
		e: HttpErrorResponse,
		cfg?: { hidden?: boolean; defaultMsj?: string }
	) {
		let error = "";
		if (e) {
			switch (e.status) {
				case 400:
					error =
						"El servidor no pudo completar la solicitud, si el problema persiste contacte con el administrador.";
					break;
				case 401:
					error = "Sesión expirada, Inicie sesión nuevamente.";
					break;
				case 403:
					error =
						"No tienes acceso a nuestros servidores, revisa tu configuración de conexión, Proxy, VPN u otras.";
					break;
				case 404:
					error = "El servidor no pudo encontrar el contenido solicitado.";
					break;
				case 405:
					error =
						"El método solicitado es conocido por el servidor pero ha sido deshabilitado y no puede ser utilizado.";
					break;
				case 407:
					error =
						"Necesitas autenticarte en tu proxy antes de utilizar la App.";
					break;
				case 408:
				case 504:
					error = "Tiempo de espera agotado.";
					break;
				case 429:
					error =
						"Se han enviado muchas solicitudes al servidor, espera unos minutos y vuelve a intentarlo.";
					break;
				case 503:
					error =
						"Nuestros servidores no estan disponibles, intente mas tarde o si el problema persiste avise al administrador del sistema.";
					break;

				default:
					error = cfg?.defaultMsj ?? "¡Vaya! Ocurrío un error inesperado.";
					break;
			}

			if (!cfg?.hidden) {
				this.toast.show("Error", error, "error");
			}
		}

		return error;
	}

	getLocationType(type: string) {
		return this.categoryType(type);
	}

	async notNull(el: Function, sec: number = 10) {
		return new Promise((resolve) => {
			let c = 0;
			const i = setInterval(() => {
				if (el() || c >= sec * 10) {
					clearInterval(i);
					resolve(el());
				}
				c++;
			}, 100);
		});
	}

	public getNotificationStatus(status) {
		return status === 0 ? "Sin leer" : "Leída";
	}

	/**
	 * Función para mostrar estado de autodiagnostico
	 * @param testing
	 * @returns
	 */
	public getTestingStatus(testing) {
		let status = "";
		if (
			testing.step_one === 1 &&
			testing.step_two === 0 &&
			testing.verified === 0
		) {
			return (status = "PREPARADO PARA INICIAR CERTIFICACIÓN");
		}

		if (
			testing.step_one === 1 &&
			testing.step_two === 1 &&
			testing.verified === 0
		) {
			return (status = "EN PROCESO DE VERIFICACIÓN");
		}

		if (testing.verified === 1 && testing.improvement_documents.length === 0) {
			return (status = "A LA ESPERA DE DOCUMENTO DE CERTIFICACIÓN");
		}

		if (testing.verified === 1 && testing.improvement_documents) {
			return (status = "CERTIFICADO");
		}

		return (status = "ESTADO DESCONOCIDO");
	}

	/**
	 * Función para color de botón de estado de autodiagnóstico
	 * @param testing
	 * @returns
	 */
	public getTestingStatusStyle(testing) {
		let style = "";
		if (
			testing.step_one === 1 &&
			testing.step_two === 0 &&
			testing.verified === 0
		) {
			return (style = "danger");
		}

		if (
			testing.step_one === 1 &&
			testing.step_two === 1 &&
			testing.verified === 0
		) {
			return (style = "warning");
		}

		if (testing.verified === 1) {
			return (style = "success");
		}

		return (style = "info");
	}
}
